import {FC, useEffect, useState} from "react";
import {dateTimeFromTicks, formatDateTimeAsFriendlyString} from "../../util/DateHelper";

export interface RelativeDateTimeProps {
    dateTime: number | null | undefined;
    fallbackText?: string;
    showPrefix?: boolean;
}

// Renders a date time that is relative to the current time, updating it as required
export const RelativeDateTime: FC<RelativeDateTimeProps> = ({dateTime, fallbackText, showPrefix}) => {

    const dateTimeValue = dateTime ? dateTimeFromTicks(dateTime) : null;

    const [dateTimeString, setDateTimeString] = useState<string>(formatDateTimeAsFriendlyString(dateTimeValue, false, showPrefix));

    useEffect(() => {
        const interval = setInterval(() => setDateTimeString(formatDateTimeAsFriendlyString(dateTimeValue, false, showPrefix)), 10000);
        return () => clearInterval(interval);
    }, [dateTimeValue, showPrefix]);

    return <>{dateTimeString || fallbackText}</>;
}
